<template>
  <v-container class="d-flex align-stretch flex-wrap">
    <v-row>
      <v-col cols="4">

        <v-card
          class="elevation-16 mx-auto"
        >
          <v-card-title class="text-h5">
            Pagamentos Últimos 4 Meses
          </v-card-title>
          <v-card-text>
              <bar-chart :chart-data="dataPgtosMeses" :options="options" :width="chartWidth" :height="chartHeigth"></bar-chart>
          </v-card-text>
        </v-card>          
      </v-col>
      <v-col cols="4">
        <v-card
          class="elevation-16 mx-auto"
        >
          <v-card-title class="text-h5">
            Score Processos Mês Atual
          </v-card-title>
          <v-card-text>
              <doughnut-chart :chart-data="dataProcessos" :options="options" :width="chartWidth" :height="chartHeigth"></doughnut-chart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BarChart from "./BarChart"
import DoughnutChart from "./DoughnutChart.vue"
import apiClient from '@/plugins/axios'

export default {
  components: {
    BarChart,
    DoughnutChart
  },
  data() {
    return {
      dataPgtosMeses: {},
      dataProcessos: {},
      chartWidth: 200,
      chartHeigth: 100,
      options: {responsive: true, maintainAspectRatio: true},
    }
  },
  mounted() {
    this.fillChartProcessos()
    this.fillData([0,0,0,0],[0,0,0,0],[0,0,0,0]);
    this.getValores()
  },
  watch: {
    dataPgtosMeses(novo) {
      return novo
    }
  },
  methods: {
    getValores() {
      apiClient.get('charts/pagamentostrial')
      .then(resp => {
        if (resp.data.status) {
          let pago = resp.data.pago ? resp.data.pago : {}
          let prev = resp.data.previsto ? resp.data.previsto : {}
          let labels = []
          let dataPg = []
          for (const key in pago) {
            labels.push(key)
            dataPg.push(pago[key])
          }
          let dataPv = []
          for (const key in prev) {
            dataPv.push(prev[key])
          }
          this.fillData(labels, dataPg, dataPv)
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    fillData(labels, dataPg, dataPv) {
      this.dataPgtosMeses = {
        // labels:["Janeiro", "Fevereiro", "Março"],
        labels: Object.assign([], labels),
        datasets: [
          {
            label: 'Provisões',
            // data: [75000, 54000, 92000],
            data: Object.assign([], dataPv),
            backgroundColor: [
              'rgba(255, 19, 0, 0.2)',
              'rgba(255, 109, 0, 0.2)',
              'rgba(255, 105, 0, 0.2)',
              'rgba(75, 92, 0, 0.2)',
              'rgba(54, 62, 0, 0.2)',
              'rgba(153, 42, 0, 0.2)',
              'rgba(201, 23, 0, 0.2)'
            ],
            borderColor: [
              'rgb(255, 19, 0)',
              'rgb(255, 109, 0)',
              'rgb(255, 105, 0)',
              'rgb(75, 92, 0)',
              'rgb(54, 62, 0)',
              'rgb(153, 42, 0)',
              'rgb(201, 23, 0)'
            ],
            borderWidth: 1
          },
          {
            label: 'Pagamentos',
            // data: [75000, 54000, 92000],
            data: Object.assign([], dataPg),
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 205, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(201, 203, 207, 0.2)'
            ],
            borderColor: [
              'rgb(255, 99, 132)',
              'rgb(255, 159, 64)',
              'rgb(255, 205, 86)',
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)',
              'rgb(153, 102, 255)',
              'rgb(201, 203, 207)'
            ],
            borderWidth: 1,
          }
        ],
      }
    },
    fillChartProcessos() {
      this.dataProcessos = {
        labels:["Novos", "Pagos", "Pagos Honorários", "à Receber"],
        //labels: Object.assign([], labels),
        datasets: [
          {
            data: [52, 13, 21, 35],
            //data: Object.assign([], dataPv),
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 205, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)'
            ],
          }
        ]
      }
    }
  }
};
</script>

<style>
.graph {
  min-width: 200px;
  min-height: 100px;
  /*margin: 15px auto;*/
}
</style>


// WEBPACK FOOTER //
// src/views/Comum/Graficos/Graficos.vue